import { BaseEntity } from './base-entity';

export class SideMenu extends BaseEntity{
    constructor(){
        super();
    }

    Name: string;
    Url: string;
    Icon: string;
    SortIndex: number;
    TypeID: number;
    HrAfter: boolean;
    SubMenu: SideMenu[];

    Deserialize(input: any){
        //let sideMenu = new SideMenu();
        this.ID = input.ID;
        this.Name = input.Name;
        this.Icon = input.Icon;
        this.SortIndex = input.SortIndex;
        this.TypeID = input.TypeID;
        this.HrAfter = input.HrAfter;
        this.Url = input.Url;
        this.SubMenu = this.loadSubMenu(input.SubMenu);

        return this;
    }

    private loadSubMenu(input: [any]){
        if(!Array.isArray(input) || !input.length)
            return null;
            
        let subMenuList: SideMenu[] = [];
        input.forEach(subMenu => {
            subMenuList.push(new SideMenu().Deserialize(subMenu));
        })
        return subMenuList;
    }
}